import { getI18n } from 'react-i18next';

export const VALIDATION_MESSAGE_EMPTY = 'validation.message.empty';
export const VALIDATION_MESSAGE_TOO_LONG = 'validation.message.invalidLength';

export const createMessageErrorMessage = (code, params) => { // NOSONAR javascript:S3800
    let result;
    const i18n = getI18n();
    switch (code) {
        case VALIDATION_MESSAGE_EMPTY:
            result = i18n.t('messages.error.message-empty');
            break;
        case VALIDATION_MESSAGE_TOO_LONG:
            result = i18n.t('messages.error.message-too-long', { maxLetters: parseInt(params[0], 10) });
            break;
        default:
            result = undefined;
    }
    return result;
};
